export const EXLY_SUPPORT_CONSTANTS = {
  product_contact_url: "https://product.exlyapp.com/?init_contact=true",
  exly_support_url: "https://support.exlyapp.com/support/home",
  support_whatsApp_url: "https://api.whatsapp.com/send?phone=919257575709", // this number belongs to exly
};
